import { AxiosResponse } from 'axios'
import httpService from '../httpService'
import { Filter, LiveClassDetails } from '../redux/liveclasses/types'
import { CancelLiveClassPayload, CreateLiveClassPayload, EndedLiveClassUpdatePayload } from 'types/Liveclass'

export function getAllStudyPlanBatches(studyPlanId: number, params?: Record<string, any>) {
  return httpService.get(`v7/gold/studyplans/${studyPlanId}/batches/`, { params })
}

export function getLiveClasses(courseVertical?: string, packCategory?: string, filter?: Filter) {
  return httpService.get(`v7/live/`, {
    params: {
      ...filter,
      courseVertical: packCategory ? undefined : courseVertical,
      packCategory,
    },
  })
}

export function getLiveClassDetails(liveClassId: number, isElevate = false) {
  return httpService.get(`v7/live/${liveClassId}/`, {
    params: { packCategory: isElevate ? 'ELEVATE' : undefined },
  })
}

export function getLicensedUsers() {
  return httpService.get(`v7/gold/zoom-users/`)
}

export function getLiveTemplates() {
  return httpService.get(`v9/100ms/templates/`)
}

type CreateLiveClass = CreateLiveClassPayload & Pick<LiveClassDetails, 'serviceProvider'>

export function createLiveClass(payload: CreateLiveClass) {
  return httpService.post(`v7/live/`, { ...payload })
}

export function editLiveClass(
  liveClassId: number,
  payload: CreateLiveClassPayload | EndedLiveClassUpdatePayload,
) {
  return httpService.put(`v7/live/${liveClassId}/`, { ...payload })
}

/**
 * Cancel an upcoming live class, recording the deactivation reason and notes.
 * Lives on v9.1, unlike the rest of the live class endpoints (v7).
 */
export function cancelLiveClass(liveId: number, payload: CancelLiveClassPayload) {
  return httpService.post(`v9.1/live/${liveId}/cancel/`, payload)
}

export function endLiveClass(liveId: number) {
  return httpService.post(`v7/live/${liveId}/end/`)
}
export function getElevatePacks(optionalParams?: { languages?: string, isOldLiveClassCreation?: boolean, elevateCourseVersion?: 'V1' | 'V2' }) {
  return httpService.get('v7/content/sources/packs/', {
    params: { packCategory: 'ELEVATE', ...optionalParams },
  })
}

export function getElevateBatches(packId: number, params?: Record<string, any>) {
  return httpService.get(`v7/packs/${packId}/batches/`, { params })
}

export interface Faculty {
  id: number
  name: string
  role: string
}

export interface FacultiesResponse {
  page: number
  pageCount: number
  limit: number
  totalObjectCount: number
  results: Faculty[]
}

export interface FacultiesFilter {
  page?: number
  limit?: number
  name?: string
}

export function getFaculties(filters?: FacultiesFilter): Promise<AxiosResponse<FacultiesResponse>> {
  return httpService.get('v7/content/sources/faculties/', { params: filters })
}

export function getLanguages() {
  return httpService.get('v4/content/sources/languages/')
}

export function getSections(packId: number | string) {
  return httpService.get('v7/content/sources/studyplans/sections/', {
    params: { packId, category: 'NORMAL', isActive: true },
  })
}

export function getLessons(sectionId: number | string) {
  return httpService.get('v7/content/sources/elevate/lessons/', {
    params: { sectionId, isActive: true },
  })
}

export function reconvertVideo(liveId: number): Promise<AxiosResponse> {
  return httpService.post(`/v7/live/${liveId}/reconvert/`)
}


export function downloadRecrodedVideo(videoRecordingId: number): Promise<AxiosResponse> {
  return httpService.get(`/v7/live/recorded-video/${videoRecordingId}/`)
}

export function getLiveClassHistory(liveClassId: number): Promise<AxiosResponse> {
  return httpService.get(`v7/live/${liveClassId}/`)
}
